if (typeof FileUploadHandler !== 'function') {
  class FileUploadHandler {
    constructor(blockId, productFormId, propertyName, maxSize, publicKey, cdnBase) {
      this.blockId = blockId;
      this.fileInput = document.getElementById(`file-upload-${blockId}`);
      this.filenameDisplay = this.fileInput.parentElement.querySelector('.file-upload-filename');
      this.maxSize = maxSize * 1024 * 1024;
      this.propertyName = propertyName;
      this.productFormId = productFormId;
      this.publicKey = publicKey;
      this.cdnBase = (cdnBase || 'https://ucarecdn.com').replace(/\/$/, '');

      this.init();
    }

    init() {
      this.fileInput.addEventListener('change', (e) => this.handleFileChange(e));
    }

    async handleFileChange(e) {
      const file = e.target.files[0];

      if (!file) {
        this.filenameDisplay.style.display = 'none';
        return;
      }

      if (this.maxSize > 0 && file.size > this.maxSize) {
        alert(`File size exceeds the maximum allowed size of ${this.maxSize / 1024 / 1024}MB`);
        this.fileInput.value = '';
        this.filenameDisplay.style.display = 'none';
        return;
      }

      this.filenameDisplay.textContent = 'Uploading...';
      this.filenameDisplay.style.display = 'inline';

      try {
        const formData = new FormData();
        formData.append('UPLOADCARE_PUB_KEY', this.publicKey);
        formData.append('UPLOADCARE_STORE', '1');
        formData.append('file', file);

        const response = await fetch('https://upload.uploadcare.com/base/', {
          method: 'POST',
          body: formData
        });

        const responseText = await response.text();
        let uploadData;
        try {
          uploadData = JSON.parse(responseText);
        } catch (e) {
          throw new Error('Server said: ' + responseText.substring(0, 200));
        }
        if (!response.ok || !uploadData.file) throw new Error(JSON.stringify(uploadData));

        const imageUrl = `${this.cdnBase}/${uploadData.file}/${encodeURIComponent(file.name)}`;

        let hiddenInput = document.getElementById(`file-upload-${this.blockId}-data`);
        if (!hiddenInput) {
          hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.id = `file-upload-${this.blockId}-data`;
          hiddenInput.name = this.propertyName;
          hiddenInput.setAttribute('form', this.productFormId);
          this.fileInput.parentElement.appendChild(hiddenInput);
        }

        hiddenInput.value = imageUrl;
        this.fileInput.removeAttribute('name');

        this.filenameDisplay.textContent = file.name + ' \u2713';
      } catch (err) {
        console.error('Uploadcare upload error:', err);
        alert('Image upload failed: ' + err.message);
        this.fileInput.value = '';
        this.filenameDisplay.style.display = 'none';
      }
    }
  }

  window.FileUploadHandler = FileUploadHandler;
}
